module.exports = __webpack_public_path__ + "static/img/ctjiedudiyiimg1.492df9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctjiedudiyiimg1.png
// module id = XNkI
// module chunks = 5